const requiresPasswordChange = async ({next, store}) => store.getters['auth/currentUser'].requiresPasswordChange ? next({name: 'user-password-change'}) : next();

export default requiresPasswordChange;